import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

/**
 * Directive to operate with menu items
 */
@Directive({
  selector: '[buttonGroup]'
})
export class ButtonGroupDirective implements OnInit {
  private filled: string = 'esf-button--filled';
  private outlined: string = 'esf-button--outlined';
  private firstChild: any;
  private lastChild: any;

  @Input() listOfPanels: {};

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.firstChild = this.el.nativeElement.firstChild;
    this.lastChild = this.el.nativeElement.lastChild;

    const allClosed = this.checkAllPanelsIfClosed();
    if (allClosed) {
      this.renderer.addClass(this.firstChild, this.filled);
      this.renderer.addClass(this.lastChild, this.outlined);
    } else {
      this.renderer.addClass(this.lastChild, this.filled);
      this.renderer.addClass(this.firstChild, this.outlined);
    }

    this.renderer.listen(this.firstChild, 'click', event => {
      this.changeButtonState('openPanels', event);
    });
    this.renderer.listen(this.lastChild, 'click', event => {
      this.changeButtonState('closePanels', event);
    });
  }

  /**
   * Changes the button state
   */
  changeButtonState(button: string, event: any): void {
    const classList = event.target.classList;
    const isFilled = classList.contains(this.filled);
    const currentClass = isFilled ? this.filled : this.outlined;
    this.addAndRemoveClasses(currentClass, button);
  }

  /**
   * Adds and removes classes from the appropriate buttons
   */
  addAndRemoveClasses(currentClass: any, button: string): void {
    if (button === 'openPanels') {
      if (currentClass === this.filled) {
        this.renderer.removeClass(this.firstChild, this.filled);
        this.renderer.addClass(this.firstChild, this.outlined);
        this.renderer.removeClass(this.lastChild, this.outlined);
        this.renderer.addClass(this.lastChild, this.filled);
      }
    } else if (button === 'closePanels') {
      if (currentClass === this.filled) {
        this.renderer.removeClass(this.lastChild, this.filled);
        this.renderer.addClass(this.lastChild, this.outlined);
        this.renderer.removeClass(this.firstChild, this.outlined);
        this.renderer.addClass(this.firstChild, this.filled);
      }
    }
  }

  /**
   * Checks if all panels are closed
   */
  public checkAllPanelsIfClosed(): boolean {
    return Object.keys(this.listOfPanels).every(panel => this.listOfPanels[panel] === false);

  }

}
